import { produce } from 'immer'
import {
  GET_USER_CONNECTIONS_SUCCESS,
  GetUserConnectionsSuccessAction,
} from 'src/app/PeopleContacts/redux/peopleContacts.actions'
import {
  GET_PERSON_STATISTICS_SUCCESS,
  GET_PERSON_SUCCESS_ACTION,
  GetPersonActions,
  GetPersonStatisticsActions,
} from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.actions'
import { UserConnectionResponse } from 'src/models/people.models'
import { UserListModel } from 'src/models/user.models'
import { GET_ME_SUCCESS, GetMeActions } from 'src/redux/actions/auth.actions'

export interface ContactsState {
  listResponses: Record<string, UserConnectionResponse>
}

export const initialState: ContactsState = {
  listResponses: {},
}

export type Actions =
  | GetUserConnectionsSuccessAction
  | GetPersonActions
  | GetMeActions
  | GetPersonStatisticsActions

const ContactsReducer = (
  state: ContactsState = initialState,
  action: Actions,
): ContactsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ME_SUCCESS: {
        const currentUser: UserConnectionResponse = {
          id: '',
          createdAt: '',
          reason: '',
          userTo: new UserListModel(action.payload),
        }
        draft.listResponses = {
          ...draft.listResponses,
          [action.payload.id]: currentUser,
        }
        return draft
      }

      case GET_USER_CONNECTIONS_SUCCESS: {
        draft.listResponses = action.payload.userConnections.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.userTo.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }
      case GET_PERSON_SUCCESS_ACTION: {
        // This is adding user connection ids to the user id list. Should not be mixing the two ids together. Also app.people vs data.people ? Commenting this out means we can't access user from VC
        draft.listResponses = action.payload.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.userTo.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case GET_PERSON_STATISTICS_SUCCESS: {
        draft.listResponses = {
          ...draft.listResponses,
          [action.userId]: {
            ...draft.listResponses[action.userId],
            userTo: {
              ...draft.listResponses[action.userId]?.userTo,
              statistics: { ...action.payload },
            },
          },
        }

        return draft
      }
    }
  })
}

export default ContactsReducer
